// TODO(benedictkhoo): remove after assets unification is done
export enum ACCOUNT_ACTIONS {
  SET_ACCOUNT_DETAIL_LIST = 'ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST',
  SET_ACCOUNT_LIST = 'ACCOUNT_ACTIONS.SET_ACCOUNT_LIST',
}
